export default function calledclosingstatuses(state = [], action) {
  switch (action.type) {
    case 'ADD_CURRENT':
      return {
        ...state,
        calledclosingstatus: action.calledclosingstatus,
      }
    default:
      return state;
  }
}
